export const GENDER_LIST = ["Male","Female"];
export const ROLE_LIST=["Agent","AgentManager","AgencyAdmin","SuperAdmin"];
export const VISA_STATUS_LIST=["Permanent Resident","Australian Citizen","Non-Permanent Resident"];
export const JOB_TITLE_LIST=["Sales","Rental","Admin","Marketing","IT","BDM","Management"];
export const LICENSE_STATUS_LIST=["Certificate","Class 1 License","Class 2 License"];
//export const ROLE_LIST=["Agent","AgentManager","AgencyAdmin","SuperAdmin"];